"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _MeasureScrollbar = _interopRequireDefault(require("./MeasureScrollbar"));

var _Box = _interopRequireDefault(require("../../Box"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TableHead = function TableHead(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      scrollbarSize = _React$useState2[0],
      setScrollbarSize = _React$useState2[1];

  var handleScrollbarSize = _react["default"].useCallback(function (size) {
    return setScrollbarSize(size);
  });

  var context = _react["default"].useContext(_TableContext["default"]);

  var smallDisplay = context.responsive ? 'none' : 'flex';
  return _react["default"].createElement(_Box["default"], _extends({
    display: [smallDisplay, 'flex', 'flex', 'flex'],
    flexWrap: context.responsive ? 'wrap' : 'initial'
  }, props), children, context.scrolling && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_MeasureScrollbar["default"], {
    onMeasure: handleScrollbarSize
  }), scrollbarSize > 0 && _react["default"].createElement(_Box["default"], {
    width: scrollbarSize
  })));
};

TableHead.defaultProps = {
  theme: _theme["default"],
  bg: 'neutral.200'
};
var _default = TableHead;
exports["default"] = _default;